package it.neckar.lizergy.model.project.process.state

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.processStates.ProcessStateEntryId
import it.neckar.processStates.ProcessStatePhase
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("ProjectProcessStateEntry")
data class ProjectProcessStateEntry(
  override val id: ProcessStateEntryId,
  override val processState: ProjectProcessStates,
  override val assignedTo: UserLoginName,
  override val belongsTo: CompanyCode,
  override val assignedAt: IsoMillis,
  override val assignedBy: UserLoginName,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : LizergyProcessStateEntry {

  override val availableOptions: List<ProjectProcessStates>
    get() = ProjectProcessStates.entries

  override fun format(i18nConfiguration: I18nConfiguration): String {
    return processState.format(i18nConfiguration)
  }

  @Serializable
  @SerialName("ProjectProcessStates")
  enum class ProjectProcessStates : LizergyProcessStates {
    BeingEdited,
    Paused,
    Archived,

    ;

    override val inPhase: ProcessStatePhase
      get() = when (this) {
        BeingEdited -> ProcessStatePhase.InProgress
        Paused -> ProcessStatePhase.Paused
        Archived -> ProcessStatePhase.Paused
      }

    override fun format(i18nConfiguration: I18nConfiguration): String {
      return when (this) {
        BeingEdited -> "Projekt in Bearbeitung"
        Paused -> "Projekt pausiert"
        Archived -> "Projekt archiviert"
      }
    }
  }
}
